import React, { useEffect, useState } from 'react';
import { useAdminContext } from '../../hooks/useAdminContext';
import axios, { muAxios } from '../../api/axios';
import { Link, useNavigate } from 'react-router-dom';
import Select from 'react-select'; 
import { getErrorMessage } from '../../utils/errorMessage';
import { FormSkeleton, TableSkeleton } from '../../components/Skeleton';

function AdminManagerRegister({setNavbar, props}) {

    const {admin} = useAdminContext();
    const [allUser, setAllUser] = useState([]);
    const [allManager, setAllManager] = useState([]);
    const [user,setUser] = useState("");
    const [succ, setSucc] = useState("");
    const [err, setErr] = useState("");
    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);
    let options = []

    const headers = { adminToken: admin.token.adminToken };

    const loadData = () => {
        setLoading(true);
        return Promise.allSettled([
            axios.get('/api/admin/getmanager', { headers }),
            axios.get('/api/admin/exclude/manager', { headers }),
        ]).then(([managersRes, usersRes]) => {
            if (managersRes.status === 'fulfilled') {
                setAllManager(managersRes.value.data?.data || []);
            } else {
                setErr(getErrorMessage(managersRes.reason, 'Unable to receive Managers data'));
            }
            if (usersRes.status === 'fulfilled') {
                setAllUser(Array.isArray(usersRes.value.data) ? usersRes.value.data : []);
            } else {
                setErr(getErrorMessage(usersRes.reason, 'Unable to receive Users data'));
            }
        }).finally(() => setLoading(false));
    }

    useEffect(() => {
        setNavbar(false);
        loadData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

const handleSubmit = () => {
    if (!user?.value) {
        setSucc("")
        setErr('Please choose a username.')
        return
    }
    const data = {username: user.value};
    setSubmitting(true)
    axios.post('/api/admin/manager', data, { headers }).then((response) => {
        const json = response.data;
        if(json.success){
            setErr('')
            setSucc(json.success)
            setUser("")
            loadData()
        }else if(json.error){
            setSucc("")
            setErr(json.error)
        }
    }).catch((error) => {
        setSucc("")
        setErr(getErrorMessage(error, 'Unable to register manager. Please try again.'))
    }).finally(() => setSubmitting(false))
}

const deleteManager = (id) => {
    const result = window.confirm("Are you sure you want to proceed with this action?");

    if(result){
        axios.delete(`/api/admin/manager/${id}`, { headers }).then((response) => {
            if(response.data.success){
                setErr("")
                setSucc(response.data.success)
                loadData()
            }else if(response.data.error){
                setSucc("")
                setErr(response.data.error)
            }
        }).catch(error => {
            setSucc("")
            setErr(getErrorMessage(error, 'Unable to delete Manager'))
        })
    }
}




allUser.map((val,key) => {
    return options.push({value: String(val.username), label: val.username})
})



  return (
    <div className='App'>
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-lg-12 mb-4 text-center">
        <h1 className="mt-4 header-title text-center">MANAGER REGISTER</h1>
        <Link to={'/admin'}>Admin Panel</Link> <span>/ Manager Register</span>
        </div>
        <div className='col-md-5'>
        {succ && (<div class="alert alert-success" role="alert">
            {succ}
            </div>)}
            {err && (<div class="alert alert-danger" role="alert">
            {err}
            </div>)}
        <div className='card'>
            <div className='card-body'>
            {loading && allUser.length === 0 ? <FormSkeleton fields={1} /> : <>
            <label>Username</label>
          <Select placeholder='Insert Username' value={user || null} onChange={setUser} options={options}  />
          <div className="d-grid gap-2 my-2">
            <button className="btn btn-primary mt-3" onClick={handleSubmit} disabled={submitting}>{submitting ? 'Registering…' : 'Register Manager'}</button>
          </div>
            </>}
            </div>
        </div>
        </div>

        <div className='col-md-8'>
        {loading && allManager.length === 0 ? <TableSkeleton rows={6} cols={4} withToolbar={false} /> : <div className='card'>
            <div className='card-body'>
                <div className='table-responsive'>
                <table class="table">
                <thead>
                    <tr>
                    <th scope="col">#</th>
                    <th scope="col">LG Code</th>
                    <th scope="col">Name</th>
                    <th scope="col"></th>
                    </tr>
                </thead>
                <tbody>
                    {allManager.map((val, key) => {
                        return (
                            <tr key={val.id}>
                            <th scope="row">{key+1}</th>
                            <td>{val.username}</td>
                            <td>{val.name}</td>
                            <td><button className='btn btn-sm btn-danger' onClick={() => deleteManager(val.id)} >X</button></td>
                            </tr>
                        )
                    })}

                </tbody>
                </table>
                </div>
            </div>
        </div>}
        </div>

        </div>
        </div>
        </div>
  )
}

export default AdminManagerRegister